<template>
  <div class="back-spell" @click="onBack">
    <img src="@/assets/images/group/return-back.png" />
    <p>{{config.title}}</p>
  </div>
</template>

<script>
export default {
  name: "BackSpell",
  props: {
    config: {
      type: Object,
      default: () => {
        return {
          redirect: "Group",
          title: "嗨拼团"
        };
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    onBack() {
      this.$router.push({
        name: this.config.redirect
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.back-spell {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 140px;
  width: 140px;
  height: 52px;
  background: linear-gradient(
    270deg,
    rgba(255, 47, 60, 1) 0%,
    rgba(255, 130, 135, 1) 100%
  );
  border-radius: 0px 59px 59px 0px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding-left: 20px;
  img {
    width: 22px;
    height: 20px;
    margin-right: 8px;
  }
  p {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }
}
</style>
